import { normalizePubkey, npubEncode } from './keys.js';

/**
 * `herald:` URIs -- what a QR code actually contains.
 *
 * Two actions:
 *   herald:sub  -- public subscribe offer. Safe to print on a poster.
 *   herald:link -- account linking, carries a single-use token. Only ever
 *                  delivered to an already-authenticated user in-app or in an
 *                  existing email; never printed publicly.
 */

export const HERALD_SCHEME = 'herald:';

export function buildUri({ action = 'sub', root, relays = [], channel, domain, token }) {
  const params = new URLSearchParams();
  params.set('k', npubEncode(root));
  for (const relay of relays) params.append('r', relay);
  if (channel) params.set('c', channel);
  if (domain) params.set('d', domain);
  if (token) params.set('t', token);
  return `${HERALD_SCHEME}${action}?${params.toString()}`;
}

export function parseUri(uri) {
  if (typeof uri !== 'string' || !uri.startsWith(HERALD_SCHEME)) {
    throw new Error('not a herald: URI');
  }
  const rest = uri.slice(HERALD_SCHEME.length);
  const qIndex = rest.indexOf('?');
  const action = qIndex === -1 ? rest : rest.slice(0, qIndex);
  if (!['sub', 'link'].includes(action)) throw new Error(`unknown herald action "${action}"`);
  const params = new URLSearchParams(qIndex === -1 ? '' : rest.slice(qIndex + 1));

  const k = params.get('k');
  if (!k) throw new Error('herald URI is missing the sender key (k)');

  return {
    action,
    root: normalizePubkey(k),
    npub: npubEncode(k),
    relays: params.getAll('r'),
    channel: params.get('c') ?? null,
    domain: params.get('d') ?? null,
    token: params.get('t') ?? null,
  };
}
